// Collapse id-like URL path segments to ":id" so patient identifiers never
// reach CloudWatch RUM telemetry (routes embed them). Pure + dependency-free
// so it stays unit-testable. See root FRONTEND_RUM_SETUP.md (PHI posture).
export function sanitizePath(pathname) {
  if (!pathname) return "/";
  const clean = pathname.split("?")[0].split("#")[0];
  const out = clean
    .split("/")
    .map((seg) => {
      if (!seg) return seg;
      if (/^[0-9a-f]{24}$/i.test(seg)) return ":id"; // Mongo ObjectId
      if (/^\d+$/.test(seg)) return ":id"; // numeric id
      if (
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(seg)
      )
        return ":id"; // uuid
      if (/^[A-Za-z]*\d[\w-]*$/.test(seg)) return ":id"; // codes like PAT123
      return seg;
    })
    .join("/");
  return out || "/";
}
